import { baseStyles, defaultPanelStyles } from '../base-styles';

export function getStyles(accent: string, position: string): string {
  const right = position === 'bottom-right';
  const cornerH = right ? 'right: 20px;' : 'left: 20px;';

  return baseStyles(accent) + defaultPanelStyles(position) + `
    @keyframes yd-greeting-in {
      from { opacity: 0; transform: translateY(8px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    .yd-greeting-card {
      position: fixed;
      bottom: 16px;
      ${cornerH}
      width: 280px;
      background: #ffffff;
      border-radius: 16px;
      box-shadow: 0 8px 32px rgba(0,0,0,0.12);
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      z-index: 1;
      pointer-events: auto;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      animation: yd-greeting-in 0.3s ease both;
    }

    .yd-greeting-dismiss {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: #f3f4f6;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #6b7280;
      transition: background 0.15s, color 0.15s;
      flex-shrink: 0;
    }
    .yd-greeting-dismiss:hover {
      background: #e5e7eb;
      color: #1f2937;
    }

    .yd-greeting-avatar-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 4px;
    }
    .yd-greeting-avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid ${accent};
    }

    .yd-greeting-welcome {
      font-size: 14px;
      line-height: 1.55;
      color: #374151;
      text-align: center;
      padding: 0 8px;
    }

    .yd-greeting-chips {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .yd-greeting-chip {
      background: transparent;
      border: 1.5px solid ${accent};
      border-radius: 20px;
      padding: 6px 14px;
      font-size: 13px;
      color: ${accent};
      cursor: pointer;
      text-align: left;
      transition: background 0.15s, color 0.15s;
      font-family: inherit;
    }
    .yd-greeting-chip:hover {
      background: ${accent};
      color: #ffffff;
    }

    .yd-greeting-input-row {
      display: flex;
      align-items: center;
      gap: 6px;
      border-top: 1px solid #f3f4f6;
      padding-top: 10px;
    }

    .yd-greeting-input {
      flex: 1;
      border: 1px solid #e5e7eb;
      border-radius: 20px;
      padding: 7px 14px;
      font-size: 13px;
      outline: none;
      font-family: inherit;
      transition: border-color 0.15s;
    }
    .yd-greeting-input:focus {
      border-color: ${accent};
    }

    .yd-greeting-send {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: ${accent};
      color: white;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: opacity 0.15s;
    }
    .yd-greeting-send:hover {
      opacity: 0.85;
    }

    .yd-greeting-fallback-bubble {
      position: fixed;
      bottom: 16px;
      ${cornerH}
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: ${accent};
      color: white;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      transition: transform 0.2s, box-shadow 0.2s;
      z-index: 1;
      pointer-events: auto;
    }
    .yd-greeting-fallback-bubble:hover {
      transform: scale(1.05);
      box-shadow: 0 6px 20px rgba(0,0,0,0.2);
    }

    @media (max-width: 480px) {
      .yd-greeting-card {
        left: 12px;
        right: 12px;
        width: auto;
        bottom: 12px;
      }
      .yd-greeting-fallback-bubble {
        right: 16px;
        bottom: 16px;
        left: auto;
      }
    }
  `;
}
